import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo1234.png'
import _imports_1 from '@/assets/Polygon2.png'
import _imports_2 from '@/assets/Rectangle4.png'
import _imports_3 from '@/assets/Polygon3.png'
import _imports_4 from '@/assets/homefone1.png'


const _hoisted_1 = { class: "home__wrapper" }
const _hoisted_2 = { class: "home__container" }
const _hoisted_3 = { class: "home__content" }
const _hoisted_4 = { class: "home__header home-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "home-header__item home-header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Океан"),
    /*#__PURE__*/_createElementVNode("span", null, " Слов")
  ])
], -1)
const _hoisted_6 = { class: "home-header__list" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Авторизоваться", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "home-header__switch" }
const _hoisted_10 = { class: "home-main home__main" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "home-main__particles" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_12 = { class: "home-main__left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Изучай "),
  /*#__PURE__*/_createElementVNode("span", null, "иностранные слова"),
  /*#__PURE__*/_createTextVNode(" легко!")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Особенно, когда ваш телефон всегда у вас под рукой..", -1)
const _hoisted_15 = { class: "home-main__down" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "home-main__right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_17 = { class: "home__container" }
const _hoisted_18 = { class: "home-cards home__cards" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "home-cards__text" }
const _hoisted_21 = {
  id: "authContent",
  ref: "authContent",
  class: "auth home-auth"
}
const _hoisted_22 = { class: "auth__left" }
const _hoisted_23 = { class: "auth__tabs" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThemeSwitcher = _resolveComponent("ThemeSwitcher")!
  const _component_AuthSection = _resolveComponent("AuthSection")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("header", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", {
              class: "home-header__item",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollAuth && _ctx.scrollAuth(...args)))
            }, _hoisted_8),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_ThemeSwitcher)
            ])
          ])
        ]),
        _createElementVNode("main", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "home-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollAuth && _ctx.scrollAuth(...args)))
              }, "Авторизация")
            ])
          ]),
          _hoisted_16
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("section", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "home-cards__item"
          }, [
            _createElementVNode("img", {
              src: item.img,
              alt: "free"
            }, null, 8, _hoisted_19),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h3", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.text), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editLogin(false)))
            }, "Регистрация"),
            _hoisted_24,
            _createElementVNode("h3", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editLogin(true)))
            }, "Вход")
          ]),
          _createVNode(_component_AuthSection, {
            "is-login": _ctx.loginInfo,
            "errors-list": _ctx.errorsList
          }, null, 8, ["is-login", "errors-list"])
        ])
      ], 512)
    ]),
    _createVNode(_component_Footer)
  ]))
}